import React from "react";
import { Table, Badge } from "reactstrap";
import { useParams } from "react-router-dom";
import PrivilegeList from "../../PrivilegeList";

const PaymentHistory = ({ privilegeList }) => {
  const { cid, lid } = useParams();

  if (!PrivilegeList?.installmentAdjustmentTabShow) {
    return null;
  }

  return (
    
    <div>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">LID</th>
            <th scope="col">Installment No</th>
            <th scope="col">service</th>
            <th scope="col">tran_id</th>
            <th scope="col">tran_date</th>
            <th scope="col">tran_amount</th>
            <th scope="col">mode</th>
            <th scope="col">is_refunded</th>
            <th scope="col">is_rollback</th>
            <th scope="col">is_settled</th>
            <th scope="col">create_date</th>
            <th scope="col">update_date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{lid}</td>
            <td>Installment No</td>
            <td>service</td>
            <td>tran_id</td>
            <td>tran_date</td>
            <td>tran_amount</td>
            <td>mode</td>
            <td>is_refunded</td>
            <td>is_rollback</td>
            <td>is_settled</td>
            <td>create_date</td>
            <td>update_date</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default PaymentHistory;
